<template>
  <v-container pa-0>
    <v-layout class="config-row" mb-2 fill-height justify-start row v-for="val, idx in keys" :key="idx" >
      <v-flex xs1 class="button-container">
        <v-btn v-if="isRequired(idx)" small icon color="error" @click="removeRow(idx)">
          <v-icon>close</v-icon>
        </v-btn>
      </v-flex>
      <v-flex xs4 mx-1>
        <v-text-field
          solo
          hide-details
          placeholder="Key (required)"
          color="secondary"
          v-model="keys[idx]"
          @change="onChange"
          :disabled="isSite(idx) && edit"
        ></v-text-field>
      </v-flex>
      <v-flex xs8 mx-1>
        <v-combobox
          v-if="isArray(types[idx])"
          chips
          v-model="values[idx]"
          solo
          multiple
          hide-details
          color="secondary"
          :placeholder="`List values for ${keys[idx]}`"
          @change="onChange"

        >
        </v-combobox>
        <v-select
          v-else-if="isBoolean(types[idx])"
          v-model="values[idx]"
          :items="[true, false]"
          hide-details
          solo
          color="secondary"
          :placeholder="`Boolean value for ${keys[idx]}`"
          @change="onChange"
        ></v-select>
        <v-layout
          v-else-if="isObject(types[idx])"
        >
          <satellite-configuration-form
            :title="keys[idx]"
            v-model="values[idx]"
            @change="onChange"
            :required-fields="requiredKeys"
           >
           </satellite-configuration-form>
        </v-layout>
        <v-text-field
          v-else
          solo
          :type="isNumber(types[idx]) ? 'number' : 'text'"
          :placeholder="`${isNumber(types[idx]) ? 'Number' :'Text'} value for ${keys[idx]}`"
          v-model="values[idx]"
          color="secondary"
          hide-details
          @change="onChange"
          :disabled="isSite(idx) && edit"
        ></v-text-field>
      </v-flex>
      <v-flex xs1 shrink class="button-container">
        <v-menu>
          <v-btn slot="activator" v-show="!isSite(idx) "outline small icon color="info">
            <v-icon>swap_horiz</v-icon>
          </v-btn>
          <v-list class="pa-0">
            <v-subheader>
              Data Type: <span class="ml-1" style="font-weight:800">{{keys[idx]}}</span> 
            </v-subheader>
            <v-divider></v-divider>
            <v-template v-for="t in fieldTypes">
              <v-list-tile @click="changeType(idx, t)">
                <v-list-tile-content>
                  <v-list-tile-title>
                    {{t}}
                  </v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-template>
          </v-list>
        </v-menu>
      </v-flex>
    </v-layout>
    <v-layout align-center justify-center fill-height row>
      <v-flex>
        <v-btn @click="addRow" small block color="secondary"><v-icon>add</v-icon> Add row</v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
const num = "number"
const str = "string"
const obj = "object"
const bol = "boolean"
const ary = "array"
export default {
  name: "SatelliteConfigurationForm",
  components: {
  },
  data () {
    return {
      model: null,
      keys: [],
      values: [],
      types: [],
      fieldTypes: [
        str, num, bol, ary, obj
      ],
      requiredKeys: [],

    }
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    title: {
      type: String
    },
    requiredFields: {
      type: Array,
      required: true,
      default: () => {
        return []
      }
    },
    edit: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    mapModelToComponent (val) {
      // map v-model (value) to component data model
      this.reset()
      for (var k in val) {
        this.keys.push(k)
        this.values.push(val[k])
        if (Array.isArray(val[k])) {
          this.types.push(ary)
        } else if (typeof(val[k]) === 'boolean') {
          this.types.push(bol)
        } else if (typeof(val[k]) === 'string') {
          this.types.push(str)
        } else if (typeof(val[k]) === 'number') {
          this.types.push(num)
        } else {
          // object or null
          this.types.push(obj)
        }
      }
    },
    getModelFromComponent () {
      if (this.keys.length != this.values.length) {
        alert('something has gone wonky with your configuration')
      }
      let model = {}
      for (var idx in this.keys) {
        let value = this.values[idx]
        let fieldType = this.types[idx]
        if(this.keys[idx] === 'site') {
          // must remove all white spaces and none alpha characters
          value = value.replace(/\W/g, '')
        }
        // convert number to an actual number and not string
        if (this.isNumber(fieldType)) {
          if (value != null){
            value = Number(value)  
          }
        }

        model[this.keys[idx]] = value
      }
      return model
    },
    reset() {
      this.keys = []
      this.values = []
    },
    onChange () {
      this.$nextTick(()=>{
        this.emit() 
      })
    },
    isArray (val) {
      return val === ary
    },
    isBoolean (val) {
      return val === bol
    },
    isObject (val) {
      return val === obj
    },
    isString (val) {
      return val === str
    },
    isNumber (val) {
      return val === num
    },
    isSite(idx) {
      return this.keys[idx] === 'site'
    },
    addRow () {
      this.values.push("")
      this.keys.push(null)
    },
    removeRow (idx) {
      let key = this.keys[idx]
      if (this.requiredFields.indexOf(key) < 0) {
        this.values.splice(idx, 1)
        this.keys.splice(idx, 1)
        this.$nextTick(()=>{
          this.emit()
        })
      } else {
        alert (`You cannot remove ${key} key`)
      }
      
    },
    emit() {
      this.$emit('input', this.getModelFromComponent())
      this.$emit('change')
    },
    changeType(idx, type) {
      this.types[idx] = type
      if (this.isString(type)) {
        this.values[idx] = ""
      } else if (this.isArray(type)) {
        this.values[idx] = []
      } else if (this.isObject(type)) {
        this.values[idx] = {}  
      } else {
        // bool or number
        this.values[idx] = null
      }
      let newval = this.types
      this.$nextTick(()=>{
        this.types = []
        this.types = newval
        this.emit()
      })
    },
    isRequired (idx) {
      return this.requiredFields.indexOf(this.keys[idx]) < 0
    }
  },
  computed: {
  },
  mounted() {
    this.mapModelToComponent (this.value)
    // on intial map we want to add set object keys to required field
    for (var k in this.value) {
      if (typeof(this.value[k]) === 'object' && this.value[k] !== null) {
        for (var newRequiredKey in this.value[k]) {
          this.requiredKeys.push(newRequiredKey)
        }
      }
    }
  },
  watch: {
    value: function (val) {
      if (val != this.getModelFromComponent()) {
        this.mapModelToComponent(val)
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
.button-container {
  min-width:40px;
  button { 
    margin-left:5px
    margin-right:5px
  }
}
.newRow{
  border-width:0.5px;
  border-style: dashed ;
  border-color:white !important;
  border-radius:5px
}
</style>
